import { render } from "./wfm-control.vue?vue&type=template&id=38fd4bcd&scoped=true"
import script from "./wfm-control.vue?vue&type=script&lang=js"
export * from "./wfm-control.vue?vue&type=script&lang=js"

import "./wfm-control.vue?vue&type=style&index=0&id=38fd4bcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fd4bcd"]])

export default __exports__